import { io } from 'socket.io-client';
import { resolveSocketOrigin } from './constants';

const socketUrl = resolveSocketOrigin();

export const socket = io(socketUrl || undefined, {
	autoConnect: false,
	reconnection: true,
	reconnectionDelay: 1000,
	reconnectionDelayMax: 5000,
});
